import { Pipe, PipeTransform } from '@angular/core';
import * as jsonPath from 'jsonpath-plus';

@Pipe({
  name: 'jsonPath',
  standalone: true
})
export class JsonPathPipe implements PipeTransform {

  transform(source: unknown, path: string, defaultValue?: string): unknown {
    if (!source || !path) {
      return defaultValue ?? '';
    }

    return jsonPath.JSONPath({
      path,
      json: source
    });
  }

}
